import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Theme, Typography, makeStyles } from '@material-ui/core';
import TextFieldWrapper from '../../micro/TextFieldWrapper/TextFieldWrapper';
import { resetPasswordAPIcall } from '../../../redux/actions/auth/auth.actions';
import HomeFooter from '../../micro/HomeFooter/HomeFooter';
import { BASE_URL, IMAGE_PATHS } from '../../../constants/paths.constants';
import HomeNavBar from '../../micro/HomeNavBar/HomeNavBar';
import { lightGrey } from '../../../app/theme';

const useStyles = makeStyles((theme: Theme) => ({
  resetPasswordPageWrapper: {
    minHeight: 'calc(100vh - 235px)',
    padding: '17px 65px 65px',
  },
  title: {
    margin: '17px 0 49px 0',
    paddingBottom: '0.5em',
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    display: 'inline-block',
    minWidth: 465,
    color: theme.palette.secondary.main,
    fontSize: 40,
    fontWeight: 600,
  },
  form: {
    width: 400,
  },
  inputField: {
    color: lightGrey,
    textTransform: 'uppercase',
  },
  control: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 5,
  },
  submitContainer: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    borderRadius: 21,
    height: 42,
    minWidth: 104,
    marginLeft: 12,
  },
  images: {
    display: 'block',
    width: '100%',
  },
}));

const passwordResetSchema = Yup.object({
  email_address: Yup.string().email('Invalid email address').required('*Required'),
});

const PasswordReset = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <>
      <HomeNavBar />
      <div className={classes.resetPasswordPageWrapper}>
        <Typography className={classes.title}>Reset Password</Typography>
        <Formik
          initialValues={{
            email_address: '',
          }}
          validationSchema={passwordResetSchema}
          onSubmit={(values) => {
            dispatch(resetPasswordAPIcall(values));
          }}
          validateOnBlur={false}
          validateOnChange={false}
        >
          {(formProps) => (
            <form onSubmit={formProps.handleSubmit} className={classes.form}>
              <div className={classes.control}>
                <TextFieldWrapper
                  form={formProps}
                  inputLabelProps={{ className: classes.inputField }}
                  label="EMAIL ADDRESS*"
                  formKey="email_address"
                  variant="outlined"
                />
              </div>
              <div className={classes.submitContainer}>
                <Button variant="contained" color="secondary" className={classes.button} href="../login">
                  Cancel
                </Button>

                <Button className={classes.button} type="submit" variant="contained" color="secondary">
                  Send Email
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </div>
      <div>
        <img
          className={classes.images}
          src={`${BASE_URL}${IMAGE_PATHS.TRICOLOR_BAR.path}`}
          alt={`${IMAGE_PATHS.TRICOLOR_BAR.alt}`}
        />
        <HomeFooter />
      </div>
    </>
  );
};

export default PasswordReset;
